module.exports = __webpack_public_path__ + "static/media/bmove.e44dcd7a.svg";